export default __webpack_public_path__ + "locales/sr-Cyrl-RS/FilesSettings.json?hash=5fb6a5ac34c91421ee14f1f3f19faed7";